import api from '..'
import type { MarketingSpendPayload } from './createMarketingSpend'

export async function updateMarketingSpend(
  id: string,
  payload: Partial<MarketingSpendPayload>,
): Promise<void> {
  await api.put(`/marketing-spend/${id}`, payload)
}
